import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    needPay_no: '', // x
    search_str: false // 搜索词
  },
  mutations: {
    changeNo(state, payload) {
      state.needPay_no = payload;
    },
    searchStr(state, payload) {
      state.search_str = payload;
    }
  },
  actions: {

  },
});
